import { fmtRelative, fmtTime } from '../format';

export function TimeStamp({ ms, relative = true }: { ms: number | Date | undefined; relative?: boolean }) {
  if (ms === undefined) return <span class="muted">—</span>;
  const t = ms instanceof Date ? ms.getTime() : ms;
  return (
    <span title={`${t} ms since epoch`}>
      {fmtTime(ms)}
      {relative && <span class="muted"> ({fmtRelative(ms)})</span>}
    </span>
  );
}
